import React from 'react';
import styles from './CategoryNav.module.css';

/**
 * @param {object} props
 * @param {string} props.selectedCategory
 * @param {React.Dispatch<string>} props.setSelectedCategory
 * @param {Array<string>} props.sortedCategories
 * @param {string=} props.className
 */
function CategoryNav({
  selectedCategory,
  setSelectedCategory,
  sortedCategories,
  className = '',
}) {
  return (
    <div className={`${styles.categoryNavWrapper} ${className}`}>
      <div className={styles.mobileCategorySelectorWrapper}>
        <label
          className={styles.mobileSelectorLabel}
          htmlFor="product-category-selector"
        >
          Select Category:
        </label>
        <select
          id="product-category-selector"
          className={styles.mobileCategorySelector}
          onChange={event => setSelectedCategory(event.target.value)}
          value={selectedCategory}
        >
          {sortedCategories.map(category => (
            <option key={category} value={category}>
              {category}
            </option>
          ))}
        </select>
      </div>
      <nav
        aria-label="Product Categories"
        className={styles.desktopCategorySelector}
        id="product-category-selector-desktop"
      >
        <ul className={styles.categoryListWrapper}>
          {sortedCategories.map(category => (
            <li
              className={
                selectedCategory === category ? styles.categoryItemActive : ''
              }
              key={category}
            >
              <button
                className={
                  selectedCategory === category
                    ? styles.buttonActive
                    : styles.button
                }
                onClick={() => {
                  setSelectedCategory(category);
                }}
                type="button"
              >
                {category}
              </button>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
}

export default CategoryNav;
